export default class UrlParser {
    public static get(url: string): URL {
        if (url.indexOf("/") == 0) {
            url = "http://unknown" + url;
        }
        return new URL(url);
    }

    public static safeDecodeURIComponent(str: string) {
        try {
            str = decodeURIComponent(str);
        } catch (e) {

        }
        return str;
    }
}